import * as React from 'react'

import StarEmptyIcon from '../icons/starEmpty'
import StarFullIcon from '../icons/starFull'
import StarHalfEmptyIcon from '../icons/starHalfEmpty'

interface IProps {
  rating: number
  maxStars?: number
  color?: string
  className?: string
}

type StarsType = typeof StarFullIcon

const StarRating = ({
  rating,
  maxStars = 5,
  color = '#fec42d',
  className
}: IProps) => {
  const stars = [] as StarsType[]
  const roundedRating = Math.round(rating * 2) / 2.0
  for (let i = 0; i < Math.floor(roundedRating); i++) {
    stars.push(StarFullIcon)
  }

  if (roundedRating % 1) {
    stars.push(StarHalfEmptyIcon)
  }

  while (stars.length < maxStars) {
    stars.push(StarEmptyIcon)
  }

  return (
    <div className={className}>
      {stars.map((Icon, index) => <Icon style={{ color }} key={index} />)}
    </div>
  )
}

export default StarRating
